module.exports = __webpack_public_path__ + "img/question_box.99adc543.svg";